import styled from 'styled-components';

export const Header = styled.div`
  display: flex;
  background-color: #fe1933;
  justify-content: space-between;
  align-items: center;
  color: white;
  height: 50px;
  width: 100%;
  padding: 0 8px;
  text-align: center;
  border-radius: 6px 6px 0 0;

  color: #fff;
  font-family: Poppins;
  font-size: 20px;
  font-style: normal;
  font-weight: 900;
  line-height: normal;
`;

export const Bloco = styled.div`
  min-width: 300px;
  padding: 0px;
  display: flex;
  flex-direction: column;
  background: white;
  border-radius: 8px;
  border: solid 1px #fe1933;
  border-color: #fb4a20;
  filter: drop-shadow(0 0 4px rgba(0, 0, 0, 0.2));
  flex-basis: 33%;
  max-width: 33%;
  flex-grow: 1;
`;
